import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OptimizationOverlayComponent } from 'src/app/+installations/installations/optimization-overlay/optimization-overlay.component';

@Injectable({ providedIn: 'root' })
export class OptimizationBannerService {
  constructor(private dialog: MatDialog) {}

  openOptimizationOverlay(): void {
    this.dialog.open(OptimizationOverlayComponent, {
      panelClass: 'installations-announcement-banner',
      width: '800px',
      minHeight: '300px',
      height: 'auto',
      autoFocus: false,
      disableClose: true,
    });
  }
}
